<div class="db-websites">
    @if (user?.hostingTrialExpired && userSubscription?.is_non_billable) {
        <div class="db-websites-unavailable">
            <div>
                <h2 [innerHTML]="'text_dashboardUnavailableTitle' | dbText"></h2>
                <p [innerHTML]="'text_dashboardUnavailableDescription' | dbText"></p>
                @if (companyInfo?.branding?.contact_email || companyInfo?.branding?.phone_number) {
                    <hr>
                    <div class="ds-agency-info">
                        @if (companyInfo?.branding?.contact_email) {
                            <div class="ds-agency-info-email">
                                <i class="db-icon db-icon-ds-contact-email"></i>
                                <span [innerHTML]="companyInfo.branding.contact_email"></span>
                            </div>
                        }
                        @if (companyInfo?.branding?.phone_number) {
                            <div class="ds-agency-info-phone">
                                <i class="db-icon db-icon-ds-contact-phone"></i>
                                <span [innerHTML]="companyInfo.branding.phone_number"></span>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
    @else {
        <div *ngIf="fromPaypalRecurringMessage" class="db-server-error">{{'text_yourPaymentFailed' | dbText}}</div>
        <div *ngIf="fromPaypalExecuteAgreementMessage" class="db-server-error">{{ 'text_executedAgreementCreationFailed' | dbText }}</div>
        <div class="db-websites__content">
            <div class="db-welcome">
                <div>
                    <!--<h3>{{firstTime && websites?.length ? 'Welcome' : 'Websites'}}</h3>
                    <p *ngIf="firstTime">Wishing you a productive day ahead.</p>-->
                </div>
                <db-websites-controls
                        *ngIf="!dedicatedHosting && currentWorkspace?.roleId !== clientRoles.SITE_DEV
    && ((websites$ | async)?.length
    || (!(websites$ | async)?.length
    && [UserSubscriptionType?.FREE, UserSubscriptionType?.PLATFORM, UserSubscriptionType?.DEDICATEDVM, UserSubscriptionType?.BOOSTER].includes(userSubscription?.type)
    ))"
                        [class.four]="(userSubscription?.plan?.services?.speed_optimizer
       && !(userSubscription.boosterProClient || userSubscription?.platformPaidClient))
        || (!userSubscription?.isDedicatedVM && userSubscription?.isAgency)"
                        [class.not-empty]="websites?.length > 0"
                        [userLocalStorage]="userLocalStorage"
                        [workspaceRole]="currentWorkspace?.roleId"
                        [userSubscription]="userSubscription"
                        [user]="user"
                        [canBuyAdditionalWebsite]="userSubscription?.boosterProClient ? userSubscription?.plan?.additionalCDNParameterPrice : userSubscription?.plan?.additionalDomainParameterPrice"
                        [disableControls]="disableControls || !!isUploading"
                        [hostedWebsitesCount]="hostedWebsitesCount"
                        [isUploading]="!!uploadingStarted && !!disableControls"
                        [percent]="ongoingMigrationActivity?.progress"
                        [hasOngoingMigrationActivity]="hasOngoingMigrationActivity"
                        [ongoingMigrationActivity]="ongoingMigrationActivity"
                        [websitesCount]="websites?.length"
                        [enabledCdnCount]="enabledCdnCount?.length"
                        [additionalWebsitesCount]="userSubscription?.boosterProClient ? userSubscription?.plan?.additionalCDNCount : user?.additionalWebsiteCount"
                        [hostedAndSpeedWebsitesCount]="hostedAndSpeedWebsites?.length"
                        [hostedWebsitesWithMultiCount]="hostedWebsitesWithMulti?.length"
                        [hostingLimit]="hostingsLimit"
                        [hasHostingService]="userSubscription?.plan?.services?.hosting"
                        [hasBoosterService]="userSubscription?.plan?.services?.speed_optimizer"></db-websites-controls>
            </div>

            <db-website-prompt *ngIf="!!userSubscription?.plan?.services?.hosting && !userSubscription?.boosterCategory"
                               [user]="user"
                               [websites]="websites"
                               [userSubscription]="userSubscription"
                               [disableControls]="disableControls"></db-website-prompt>

            <div class="db-websites__main-content" id="db-websites__main-content"
                 [ngClass]="{'blured': blured, 'db-websites__main-content-empty': !(websitesLoading$ | async) && (websites$ | async) && (websites$ | async)?.length && filteredWebsites && !filteredWebsites.length, 'not-owner-trial': !canCreateWebsite}"
                 *ngIf="!(canCreateWebsite && !(websitesLoading$ | async) && (websites$ | async) && canCreateWebsite &&  !(websites$ | async).length && filteredWebsites && !filteredWebsites.length); else noWebsites">
                <div class="db-websites__tags-searching"
                     *ngIf="!demoUser && !ownerSubscrExpired && (websites$ | async) && websites?.length">
                    <div class="db-websites__tags-filters db-websites__tags-filters-trials"
                         *ngIf="(websites$ | async) && (websites$ | async)?.length"
                         [ngClass]="{'db-websites__tags-filters-not-owner': currentWorkspace?.roleId !== clientRoles.OWNER}">
                        <div class="db-websites__filtering" *ngIf="currentWorkspace?.roleId === clientRoles.OWNER">
                            <div class="db-websites__add-tags-filters" *ngIf="currentWorkspace?.roleId === clientRoles.OWNER">
                                <label class="db-websites__select-all-toggle db-websites__select-all-trials">
              <span class="db-fc-checkbox db-websites__checkbox">
                <input type="checkbox" [formControl]="selectAll"
                       (change)="toggleAllItemsSelected($event.currentTarget.checked)">
                <span><i class="db-icon db-icon-check"></i></span>
              </span>
                                </label>
                                <div class="db-websites__divider"></div>
                                <div class="db-websites__assign-tags db-websites__assign-tags-trials" (click)="showAddTagDialog()"
                                     *ngIf="hasCheckedWebsite && !isClicked">
                                    <i class="db-icon db-icon-add-website"></i>
                                    <span class="db-websites__assign-tags-span">{{'text_assignTags' | dbText}}</span>
                                </div>
                            </div>

                            <div class="db-fc-dropdown-select db-websites__dropdown-select db-websites__dropdown-select-trials"
                                 *ngIf="(websites$ | async) && (websites$ | async).length && (!hasCheckedWebsite || isClicked) && currentWorkspace?.roleId === clientRoles.OWNER"
                                 (click)="getTagsList()">
                                <ng-multiselect-dropdown
                                        [settings]="dropdownSettings"
                                        [data]="dropdownList"
                                        [ngModel]="selectedItems"
                                        (onSelect)="onItemSelect($event)"
                                        (onDeSelect)="onItemSelect($event, true)"
                                        [dsTooltip]="test" dsTooltipAlign="top" dsTooltipSize="large"
                                        [placeholder]="' '"
                                        class="db-websites__multiselect"
                                        [ngClass]="{'empty-filters' : !selectedItems.length}"
                                >
                                </ng-multiselect-dropdown>
                                <div id="more_filtered_tags">
                                    <div>
                                        <p>Tags Assigned</p>
                                        <div id="tags-list"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="db-websites__search" *ngIf="(websites$ | async) && (websites$ | async).length">
                            <!--<div class="db-websites__toggle db-websites__toggle-trials" (click)="toggle()" [ngClass]="{'db-websites__thumbnail-view': !listView}">
                              <i class="db-icon db-icon-ds-block-view" *ngIf="listView"></i>
                              <i class="db-icon db-icon-ds-burger" *ngIf="!listView"></i>
                            </div>-->
                            <div class="db-websites-search-wrap db-websites-search-wrap-trials"
                                 *ngIf="(websites$ | async) && (websites$ | async).length">
                                <ds-search-input [formControl]="searchTerm" [placeholder]="'text_searchEllipsis' | dbText" [hasSearchIcon]="true"
                                                 [ngModel]="searchTerm.value" (ngModelChange)="onChangePage(1, true)"></ds-search-input>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="db-websites__items"
                     *ngIf="!ownerSubscrExpired && !(websitesLoading$ | async) && (websites$ | async) && (websites$ | async)?.length && filteredWebsites && filteredWebsites?.length">
                    <div [ngClass]="{'db-websites__grid-content' : !isAiBuilderDemo,
             'db-trial' :  (overlayWebsiteTrial || (hostedWebsites?.length === 0
             && (userSubscription && (userSubscription.trialClient || userSubscription.trialBoosterClient )
                 || userSubscription?.subscriptionId === Config.defaultStarterPlanId)))
               && !overlayWebsite && !loading && connectedWebsites?.length && !loadingAfterConnect,
               'db-websites__grid-content-ai-builder-demo' : isAiBuilderDemo}">
                        <!--          <ds-mobile-page-title class="ds-mobile-page-title-centered"></ds-mobile-page-title>-->
                        <ng-container
                                *ngFor="let website of (filteredWebsites | sortBy: sortBy?.value: 'desc' | pagination : {'currentPage': currentPage,'itemsPerPage': itemsPerPage}); let i = index">
                            <ng-container>
                                <db-website-item
                                        [ngClass]="{'db-website-item-list-view_multisite': website.isNetwork && !website.parentId}"
                                        [website]="website" [hostedWebsiteLimit]="hostingsLimit"
                                        [hostedWebsitesCount]="hostedWebsites?.length"
                                        [hostedWebsitesIncludedMultiCount]="hostedWebsitesWithMulti?.length"
                                        [disableMigrateButton]="disableControls || !!isUploading"
                                        (toggled)="updateSelectAllState()" [allTagsList]="tagsList" [user]="user"
                                        [userSubscription]="userSubscription" (refresh)="refreshClicked()"
                                        [parentLoading]="loadingAfterConnect"
                                        (openDemoIframe)="openIframe($event)"
                                        [demoUser]="demoUser">
                                </db-website-item>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>

                <db-empty-search [hideImage]="true" class="db-website-empty-search"
                                 *ngIf="(websites$ | async) && (websites$ | async).length && filteredWebsites && !filteredWebsites.length && !(websitesLoading$ | async)"></db-empty-search>
            </div>

            <ng-template #noWebsites>
                <db-no-websites *ngIf="!userSubscription?.trialBoosterClient && canCreateWebsite"></db-no-websites>
            </ng-template>

            <div class="db-websites__main-content" [ngClass]="{'db-websites__main-content-empty': !(websitesLoading$ | async)
     && (websites$ | async) && (websites$ | async).length && filteredWebsites
      && !filteredWebsites.length, 'not-owner-trial': !canCreateWebsite}"
                 *ngIf="!canCreateWebsite && (websites$ | async) &&  !(websites$ | async).length && filteredWebsites && !filteredWebsites.length">
                <div
                        *ngIf="currentWorkspace && [clientRoles.COMPANY_DEV, clientRoles.SITE_DEV].includes(currentWorkspace.roleId) && ownerSubscrExpired"
                        class="db-no-website-access">
                    You have no access. Subscription is expired. <br> For more information, please contact workspace owner.
                </div>
                <div *ngIf="!canCreateWebsite && !(websitesLoading$ | async)
      && (websites$ | async) && !(websites$ | async).length && !ownerSubscrExpired" class="db-no-website-access">
                    At the moment you don't have access to any website.<br> For more information please contact workspace owner.
                </div>
                <db-empty-search [hideImage]="true" class="db-website-empty-search"
                                 *ngIf="(websites$ | async) && (websites$ | async).length && filteredWebsites && !filteredWebsites.length && !(websitesLoading$ | async) "></db-empty-search>
            </div>

            <div class="db-optimize-only-container"
                 *ngIf="userSubscription?.trialBoosterClient && !(websitesLoading$ | async)
     && (websites$ | async) && !(websites$ | async).length && filteredWebsites
      && !filteredWebsites.length">
                <div class="db-optimize-only-item">
                    <db-booster-plugin-download-dialog></db-booster-plugin-download-dialog>
                </div>
            </div>

            <div class="db-websites__header" *ngIf="filteredWebsites?.length && filteredWebsites?.length > itemsPerPage">
                <div class="db-websites-pagination">
                    <db-pagination-controls (onChangePage)="onChangePage($event, false)" [currentPage]="currentPage"
                                            [pagesCount]="pagesCount" [itemsPerPage]="itemsPerPage"
                                            [itemsCount]="filteredWebsites?.length"></db-pagination-controls>
                </div>
            </div>
        </div>
        <db-how-to-videos [url]="'https://www.youtube.com/embed/Jxv8yxhON6k?autoplay=1'"
                          [desc]="'Learn how to build a brand new WordPress website.'"
                          [title]="'How to Install a New Website'"></db-how-to-videos>
    }

</div>

<ng-template #test></ng-template>

<db-loading-screen *ngIf="(fromGoogleSignIn && websites?.length && websites?.length === 1) || zoneIsBeingCreate"
                   [pageBlocker]="true" [loadingMessage]="'text_websiteZoneIsBeingCreated' | dbText"></db-loading-screen>
<db-something-wrong *ngIf="showTimeoutView" [descText]="'text_websiteZoneIsFailed' | dbText"></db-something-wrong>
<!--<db-website-available-dialog *ngIf="blured" [availableWebsitesCount]="(hostingsLimit - hostedWebsitesWithMulti.length)"
                             (_closeDialog)="availablePluginsGotIt(false, true)"></db-website-available-dialog>-->

